import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { clientDocumentAPI } from '../services/api';

/**
 * Opened in a new tab via notification links (e.g. "View consent").
 * Fetches the document using the app's existing auth context and
 * redirects the tab to the blob URL so the file opens natively.
 */
export default function DocumentViewer() {
  const { fileId } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const response = await clientDocumentAPI.downloadFile(fileId);
        const contentType = response.headers['content-type'] || 'application/octet-stream';
        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);
        window.location.replace(url);
      } catch (err) {
        setError('Unable to load the document. It may have been deleted or you may not have access.');
      }
    }
    load();
  }, [fileId]);

  if (error) {
    return (
      <div style={{ padding: '2rem', fontFamily: 'sans-serif', color: '#495057' }}>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif', color: '#6c757d' }}>
      Loading document…
    </div>
  );
}
